export const environment = {
  production: true,
  api_get_authentication: 'https://sisproteckmotos.co/sisproteck/api/',
  api_create_authentication: 'https://sisproteckmotos.co/sisproteck/api/',
  api_delete_authentication: 'https://sisproteckmotos.co/sisproteck/api/',
  api_update_authentication: 'https://sisproteckmotos.co/sisproteck/api/'
};